module.exports = __webpack_public_path__ + "static/media/hover-full.bccab497.png";